'use strict';

;(function () {

  let addToCartBtn, mobileAddToCartBtn;
  
  function onDocumentLoaded(){
    addToCartBtn = document.querySelector('.add-to-cart:not(.cta-mobile-only)');
    mobileAddToCartBtn = document.querySelector('.add-to-cart.cta-mobile-only');

    if(mobileAddToCartBtn){
      mobileAddToCartBtn.addEventListener('click', () => {
        addToCartBtn.click();
      });
    }
  }
  
  if(document.readyState != 'loading'){
    onDocumentLoaded();
  } else {
    document.addEventListener("DOMContentLoaded", onDocumentLoaded);
  }
})();